import { template as template_ef6adbd3eaf0447a80240fa0db9cfd1e } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
/**
  An component yielded from the head.row component that is used to define
  a cell in a row of the head of the table. Would be used for filters or any other
  additional information in the table head for a column

  ```hbs
  <table.thead as |head|>
    <head.row as |row|>
      <row.cell>
        <input
          class="input" type="search" placeholder="Search last name"
          value={{this.lastNameFilter}}
          {{on "input"
            (pipe
              (pick "target.value")
              (fn (mut this.lastNameFilter))
            )
          }}
          >
      </row.cell>
    </head.row>
  </table.thead>
  ```

  @class THeadCell
  @yield {object} cell

 */ export default class THeadCell extends Component {
    static{
        template_ef6adbd3eaf0447a80240fa0db9cfd1e(`
    {{#if this.column.visible}}
      <th class='{{@class}} {{@theme.theadCell}}' ...attributes>
        {{yield}}
      </th>
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
    @tracked
    index;
    get column() {
        return this.args.prop ? this.args.columns.find((column)=>column.prop === this.args.prop) : this.args.columns[this.index];
    }
    constructor(){
        super(...arguments);
        this.index = this.args.parent?.registerCell(this);
    }
    willDestroy() {
        super.willDestroy(...arguments);
        this.args.parent?.unregisterCell(this);
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9Vc2Vycy9taWd1ZWwvd29ya3NwYWNlL2VtYmVyLXlldGktdGFibGUvZW1iZXIteWV0aS10YWJsZS9zcmMvY29tcG9uZW50cy95ZXRpLXRhYmxlL3RoZWFkL3Jvdy9jZWxsLmdqcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgQ29tcG9uZW50IGZyb20gJ0BnbGltbWVyL2NvbXBvbmVudCc7XG5pbXBvcnQgeyB0cmFja2VkIH0gZnJvbSAnQGdsaW1tZXIvdHJhY2tpbmcnO1xuXG4vKipcbiAgQW4gY29tcG9uZW50IHlpZWxkZWQgZnJvbSB0aGUgaGVhZC5yb3cgY29tcG9uZW50IHRoYXQgaXMgdXNlZCB0byBkZWZpbmVcbiAgYSBjZWxsIGluIGEgcm93IG9mIHRoZSBoZWFkIG9mIHRoZSB0YWJsZS4gV291bGQgYmUgdXNlZCBmb3IgZmlsdGVycyBvciBhbnkgb3RoZXJcbiAgYWRkaXRpb25hbCBpbmZvcm1hdGlvbiBpbiB0aGUgdGFibGUgaGVhZCBmb3IgYSBjb2x1bW5cblxuICBgYGBoYnNcbiAgPHRhYmxlLnRoZWFkIGFzIHxoZWFkfD5cbiAgICA8aGVhZC5yb3cgYXMgfHJvd3w-XG4gICAgICA8cm93LmNlbGw-XG4gICAgICAgIDxpbnB1dFxuICAgICAgICAgIGNsYXNzPVwiaW5wdXRcIiB0eXBlPVwic2VhcmNoXCIgcGxhY2Vob2xkZXI9XCJTZWFyY2ggbGFzdCBuYW1lXCJcbiAgICAgICAgICB2YWx1ZT17e3RoaXMubGFzdE5hbWVGaWx0ZXJ9fVxuICAgICAgICAgIHt7b24gXCJpbnB1dFwiXG4gICAgICAgICAgICAocGlwZVxuICAgICAgICAgICAgICAocGljayBcInRhcmdldC52YWx1ZVwiKVxuICAgICAgICAgICAgICAoZm4gKG11dCB0aGlzLmxhc3ROYW1lRmlsdGVyKSlcbiAgICAgICAgICAgIClcbiAgICAgICAgICB9fVxuICAgICAgICAgID5cbiAgICAgIDwvcm93LmNlbGw-XG4gICAgPC9oZWFkLnJvdz5cbiAgPC90YWJsZS50aGVhZD5cbiAgYGBgXG5cbiAgQGNsYXNzIFRIZWFkQ2VsbFxuICBAeWllbGQge29iamVjdH0gY2VsbFxuXG4gKi9cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFRIZWFkQ2VsbCBleHRlbmRzIENvbXBvbmVudCB7XG4gIDx0ZW1wbGF0ZT5cbiAgICB7eyNpZiB0aGlzLmNvbHVtbi52aXNpYmxlfX1cbiAgICAgIDx0aCBjbGFzcz0ne3tAY2xhc3N9fSB7e0B0aGVtZS50aGVhZENlbGx9fScgLi4uYXR0cmlidXRlcz5cbiAgICAgICAge3t5aWVsZH19XG4gICAgICA8L3RoPlxuICAgIHt7L2lmfX1cbiAgPC90ZW1wbGF0ZT5cblxuICBAdHJhY2tlZFxuICBpbmRleDtcblxuICBnZXQgY29sdW1uKCkge1xuICAgIHJldHVybiB0aGlzLmFyZ3MucHJvcCA_XG4gICAgICB0aGlzLmFyZ3MuY29sdW1ucy5maW5kKChjb2x1bW4pID0-IGNvbHVtbi5wcm9wID09PSB0aGlzLmFyZ3MucHJvcCkgOlxuICAgICAgdGhpcy5hcmdzLmNvbHVtbnNbdGhpcy5pbmRleF07XG4gIH1cblxuICBjb25zdHJ1Y3RvcigpIHtcbiAgICBzdXBlciguLi5hcmd1bWVudHMpO1xuXG4gICAgdGhpcy5pbmRleCA9IHRoaXMuYXJncy5wYXJlbnQ_LnJlZ2lzdGVyQ2VsbCh0aGlzKTtcbiAgfVxuXG4gIHdpbGxEZXN0cm95KCkge1xuICAgIHN1cGVyLndpbGxEZXN0cm95KC4uLmFyZ3VtZW50cyk7XG4gICAgdGhpcy5hcmdzLnBhcmVudD8udW5yZWdpc3RlckNlbGwodGhpcyk7XG4gIH1cbn1cbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsT0FBTyxlQUFlLHFCQUFxQjtBQUMzQyxTQUFTLE9BQU8sUUFBUSxvQkFBb0I7QUFFNUM7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztDQTJCQyxHQUNELGVBQWUsTUFBTSxrQkFBa0I7SUFDckMsTUFBQTtRQUFBLDBDQUFVLENBQUE7Ozs7OztFQU1WLENBQUEsRUFBQTtZQUFBLFdBQUEsSUFBVztZQUFYO2dCQUFBLE9BQUEsS0FBQSxTQUFBLENBQUEsRUFBVztZQUFEO1FBQUE7SUFBQSxDQU5BO0lBUVYsQ0FBQztJQUNELE1BQU07SUFFTixJQUFJLFNBQVM7UUFDWCxPQUFPLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSSxHQUNuQixJQUFJLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQyxTQUFXLE9BQU8sSUFBSSxLQUFLLElBQUksQ0FBQyxJQUFJLENBQUMsSUFBSSxJQUNqRSxJQUFJLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDO0lBQ2pDO0lBRUEsYUFBYztRQUNaLEtBQUssSUFBSTtRQUVULElBQUksQ0FBQyxLQUFLLEdBQUcsSUFBSSxDQUFDLElBQUksQ0FBQyxNQUFNLEVBQUUsYUFBYSxJQUFJO0lBQ2xEO0lBRUEsY0FBYztRQUNaLEtBQUssQ0FBQyxlQUFlO1FBQ3JCLElBQUksQ0FBQyxJQUFJLENBQUMsTUFBTSxFQUFFLGVBQWUsSUFBSTtJQUN2QztBQUNGIn0